/// <amd-module name="Test/AttachmentsView/TestAttachmentModel" />
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { TestLogListItem } from "Test/common-util/Contracts/ExtendedTest"; 
export class TestAttachmentModel {
    /**
     * Legacy attachment.
     */
    legacyAttachments: TCMContracts.TestAttachment[];

    /**
     * Logstore attachment.
     */
    logStoreAttachments: TestLogListItem[];

    getLegacyAttachments(): TCMContracts.TestAttachment[] {
        return this.legacyAttachments;
    }

    setLegacyAttachments(legacyAttachments: TCMContracts.TestAttachment[]) {
        this.legacyAttachments = legacyAttachments;
    }

    getLogStoreAttachments(): TestLogListItem[] {
        return this.logStoreAttachments;
    }

    setLogStoreAttachments(logStoreAttachments: TestLogListItem[]) {
        this.logStoreAttachments = logStoreAttachments;
    }    
}
